<template>
  <div class="home-container">
    <!-- 导航栏 -->
    <div class="header-container">
      <el-header class="header">
        <div class="logo">
          <h1>肌肤之享</h1>
          <div class="logo-subtitle">您的专业护肤分享社区</div>
        </div>
        <el-menu
          :default-active="activeIndex"
          class="menu"
          mode="horizontal"
          router
          @select="handleSelect"
          background-color="#fff"
          text-color="#606266"
          active-text-color="#409eff"
        >
          <el-menu-item index="/">
            <el-icon><HomeFilled /></el-icon>
            <span>首页</span>
          </el-menu-item>
          <el-menu-item index="/announcement">
            <el-icon><Bell /></el-icon>
            <span>系统公告</span>
          </el-menu-item>
          <el-menu-item index="/Skincare">
            <el-icon><Goods /></el-icon>
            <span>护肤产品</span>
          </el-menu-item>
          <el-menu-item index="/collection">
            <el-icon><Star /></el-icon>
            <span>我的收藏</span>
          </el-menu-item>
          <el-menu-item index="/notes">
            <el-icon><Notebook /></el-icon>
            <span>护肤笔记</span>
          </el-menu-item>
          <el-menu-item index="/knowledge">
            <el-icon><Reading /></el-icon>
            <span>护肤知识</span>
          </el-menu-item>
        </el-menu>
        <div class="user-actions">
          <template v-if="isLoggedIn">
            <div class="welcome-user">
              <span class="welcome-text">欢迎，{{ userInfo.nickname || userInfo.username }}</span>
              <el-button size="small" type="primary" @click="router.push('/profile')"><el-icon><User /></el-icon> 个人中心</el-button>
              <el-button size="small" type="danger" @click="handleLogout">退出登录</el-button>
            </div>
          </template>
          <template v-else>
            <el-button type="primary" plain round @click="router.push('/login')"><el-icon><User /></el-icon> 登录</el-button>
            <el-button type="success" round @click="router.push('/login?tab=register')"><el-icon><Plus /></el-icon> 注册</el-button>
            <el-button type="info" plain round @click="handleProfileClick"><el-icon><User /></el-icon> 个人中心</el-button>
          </template>
        </div>
      </el-header>
    </div>

    <!-- 轮播图区域 -->
    <div class="carousel-container">
      <el-carousel height="400px" indicator-position="outside" arrow="always">
        <el-carousel-item v-for="item in carouselItems" :key="item.id" @click="handleCarouselClick(item)">
          <div class="carousel-content" :style="{ backgroundImage: `url(${item.imgUrl})` }">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
            <el-button type="primary" size="large" round v-if="item.linkUrl">了解更多</el-button>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 内容区域 -->
    <div class="content-container">
      <!-- 热门推荐 -->
      <el-row class="section">
        <el-col :span="24">
          <div class="section-header">
            <h2>热门推荐</h2>
            <el-link type="primary" @click="router.push('/Skincare')">查看更多</el-link>
          </div>
        </el-col>
        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="item in hotProducts" :key="item.id" class="product-card-container">
              <el-card class="product-card" :body-style="{ padding: '0px' }" @click="router.push(`/product/${item.id}`)">
                <img :src="item.imgUrl" class="product-image" />
                <div class="product-info">
                  <h3>{{ item.name }}</h3>
                  <p class="product-desc">{{ item.description }}</p>
                  <div class="product-bottom">
                    <div class="tags">
                      <el-tag size="small" v-for="tag in item.tags" :key="tag" type="success">{{ tag }}</el-tag>
                    </div>
                    <div class="actions">
                      <el-button 
                        :type="item.isCollected ? 'success' : 'primary'" 
                        size="small" 
                        circle 
                        @click.stop="handleCollect(item)"
                        :loading="item.collectLoading"
                      >
                        <el-icon><Star /></el-icon>
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- 护肤攻略 -->
      <el-row class="section">
        <el-col :span="24">
          <div class="section-header">
            <h2>护肤攻略</h2>
            <el-link type="primary" @click="router.push('/notes')">查看更多</el-link>
          </div>
        </el-col>
        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" v-for="item in skincareTips" :key="item.id" class="tip-card-container">
              <el-card 
                class="tip-card" 
                shadow="hover" 
                @click="router.push(`/notes/${item.id}`)"
                :body-style="{ padding: '0px' }"
              >
                <div class="tip-image" v-if="item.image">
                  <img :src="item.image" :alt="item.title">
                </div>
                <div class="tip-content">
                  <div class="tip-header">
                    <h3>{{ item.title }}</h3>
                    <el-tag size="small" :type="item.type">{{ item.category }}</el-tag>
                  </div>
                  <p class="tip-desc">{{ item.content }}</p>
                  <div class="tip-products" v-if="item.products && item.products.length > 0">
                    <el-tag 
                      v-for="product in item.products" 
                      :key="product"
                      size="small"
                      effect="plain"
                      class="product-tag"
                    >
                      {{ product }}
                    </el-tag>
                  </div>
                  <div class="tip-footer">
                    <div class="author">
                      <span>{{ item.authorName }}</span>
                    </div>
                    <span class="date">{{ item.createTime }}</span>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- 用户分享 -->
      <!-- <el-row class="section">
        <el-col :span="24">
          <div class="section-header">
            <h2>用户分享</h2>
            <el-link type="primary">查看更多</el-link>
          </div>
        </el-col>
        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="item in userShares" :key="item.id" class="share-card-container">
              <el-card class="share-card" shadow="hover">
                <img :src="item.imgUrl" class="share-image" />
                <div class="share-info">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.content }}</p>
                  <div class="share-footer">
                    <span class="author">
                      <el-avatar :size="24" :src="item.userAvatar"></el-avatar>
                      {{ item.username }}
                    </span>
                    <div class="stats">
                      <span><el-icon><View /></el-icon> {{ item.views }}</span>
                      <span><el-icon><Star /></el-icon> {{ item.likes }}</span>
                      <span><el-icon><ChatSquare /></el-icon> {{ item.comments }}</span>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row> -->
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { 
  Star, 
  // Share, 
  // View, 
  // ChatSquare, 
  HomeFilled, 
  Bell, 
  Goods, 
  Notebook, 
  Reading,
  User,
  Plus
} from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox} from 'element-plus'
import { api, setAuthToken } from '../utils/axios'

export default {
  name: 'HomeView',
  components: {
    Star,
    // Share,
    // View,
    // ChatSquare,
    HomeFilled,
    Bell,
    Goods,
    Notebook,
    Reading,
    User,
    Plus
  },
  setup() {
    const router = useRouter()
    const activeIndex = ref('/')
    const isLoggedIn = ref(false)
    const userInfo = ref({})
    const carouselItems = ref([])
    const loadingCarousel = ref(false)
    const hotProducts = ref([])
    const loadingHotProducts = ref(false)
    const skincareTips = ref([])
    const loadingSkincareTips = ref(false)
    
    // 检查用户登录状态
    const checkLoginStatus = async () => {
      try {
        // 检查本地存储是否有登录信息
        const token = localStorage.getItem('token')
        const storedUser = localStorage.getItem('user')
        
        if (token && storedUser) {
          // 先从本地存储设置用户信息
          userInfo.value = JSON.parse(storedUser)
          isLoggedIn.value = true
          
          // 然后从服务器验证令牌并获取最新数据
          const response = await api.getUserInfo()
          if (response.success && response.data.isLoggedIn) {
            userInfo.value = response.data.user
            isLoggedIn.value = true
            // 更新本地存储
            localStorage.setItem('user', JSON.stringify(userInfo.value))
          } else {
            // 如果令牌无效，清除本地存储
            isLoggedIn.value = false
            localStorage.removeItem('token')
            localStorage.removeItem('user')
          }
        }
      } catch (error) {
        console.error('检查登录状态失败:', error)
      }
    }
    
    // 处理退出登录
    const handleLogout = () => {
      ElMessageBox.confirm(
        '确定要退出登录吗?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        // 清除令牌和用户信息
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        setAuthToken(null)
        isLoggedIn.value = false
        userInfo.value = {}
        ElMessage.success('已成功退出登录')
      }).catch(() => {})
    }

    const handleSelect = (key) => {
      console.log(key)
    }

    // 获取轮播图数据
    const fetchCarouselData = async () => {
      loadingCarousel.value = true
      try {
        const response = await api.getCarousel()
        if (response.success && response.data) {
          carouselItems.value = response.data.map(item => ({
            id: item.id,
            title: item.title,
            description: item.description,
            imgUrl: item.img_url,
            linkUrl: item.link_url
          }))
        } else {
          // 如果API调用失败，使用默认数据
          setDefaultCarouselData()
        }
      } catch (error) {
        console.error('获取轮播图数据失败:', error)
        // 出错时使用默认数据
        setDefaultCarouselData()
      } finally {
        loadingCarousel.value = false
      }
    }

    // 设置默认轮播图数据（服务器无法访问时使用）
    const setDefaultCarouselData = () => {
      carouselItems.value = [
        {
          id: 1,
          title: '春季护肤专题',
          description: '告别干燥，迎接水润新肌肤',
          imgUrl: 'https://img.freepik.com/free-photo/top-view-skincare-products-arrangement_23-2149114138.jpg'
        },
        {
          id: 2,
          title: '敏感肌必备清单',
          description: '温和呵护，修复屏障',
          imgUrl: 'https://img.freepik.com/free-photo/flat-lay-natural-self-care-products-composition_23-2148990019.jpg'
        },
        {
          id: 3,
          title: '美白淡斑神器',
          description: '亮白肌肤，告别暗沉',
          imgUrl: 'https://img.freepik.com/free-photo/arrangement-with-beauty-products-beige-background_23-2148567497.jpg'
        }
      ]
    }

    // 处理轮播图点击
    const handleCarouselClick = (item) => {
      if (item.linkUrl) {
        // 检查链接是否是内部链接
        if (item.linkUrl.startsWith('/')) {
          router.push(item.linkUrl)
        } else {
          // 外部链接，在新标签页打开
          window.open(item.linkUrl, '_blank')
        }
      }
    }

    // 获取热门推荐产品
    const fetchHotProducts = async () => {
      loadingHotProducts.value = true
      try {
        const response = await api.getHotProducts()
        if (response.success && response.data) {
          hotProducts.value = response.data.map(item => ({
            id: item.id,
            name: item.name,
            description: item.description,
            imgUrl: item.img_url,
            tags: item.tags ? item.tags.split(',') : [],
            collection_count: item.collection_count || 0,
            isCollected: false,
            collectLoading: false
          }))
          
          // 如果用户已登录，检查每个产品的收藏状态
          if (isLoggedIn.value) {
            checkProductsCollectionStatus()
          }
        } else {
          // 如果API调用失败，使用默认数据
          setDefaultHotProductsData()
        }
      } catch (error) {
        console.error('获取热门推荐产品失败:', error)
        // 出错时使用默认数据
        setDefaultHotProductsData()
      } finally {
        loadingHotProducts.value = false
      }
    }

    // 检查产品收藏状态
    const checkProductsCollectionStatus = async () => {
      for (const product of hotProducts.value) {
        try {
          const response = await api.checkCollection(product.id, 'product')
          if (response.success) {
            product.isCollected = response.data.isCollected
          }
        } catch (error) {
          console.error(`检查产品 ${product.id} 收藏状态失败:`, error)
        }
      }
    }

    // 设置默认热门推荐产品数据（服务器无法访问时使用）
    const setDefaultHotProductsData = () => {
      hotProducts.value = [
        {
          id: 1,
          name: '玻尿酸精华液',
          description: '深层保湿，修复肌肤屏障',
          imgUrl: 'https://img.freepik.com/free-photo/arrangement-with-natural-cosmetic-products_23-2148608356.jpg',
          tags: ['保湿', '修复'],
          collection_count: 0,
          isCollected: false,
          collectLoading: false
        },
        {
          id: 2,
          name: '维C美白精华',
          description: '淡化斑点，均匀肤色',
          imgUrl: 'https://img.freepik.com/free-photo/variety-skincare-products-arrangement_23-2148614122.jpg',
          tags: ['美白', '抗氧化'],
          collection_count: 0,
          isCollected: false,
          collectLoading: false
        },
        {
          id: 3,
          name: '神经酰胺面霜',
          description: '深层滋养，恢复弹性',
          imgUrl: 'https://img.freepik.com/free-photo/arrangement-with-natural-skincare-containers_23-2148533946.jpg',
          tags: ['滋养', '保湿'],
          collection_count: 0,
          isCollected: false,
          collectLoading: false
        },
        {
          id: 4,
          name: '水杨酸焕肤精华',
          description: '温和去角质，改善肤质',
          imgUrl: 'https://img.freepik.com/free-photo/natural-skincare-products-arrangement_23-2148613280.jpg',
          tags: ['去角质', '焕颜'],
          collection_count: 0,
          isCollected: false,
          collectLoading: false
        }
      ]
    }

    // 获取护肤攻略数据
    const fetchSkincareTips = async () => {
      loadingSkincareTips.value = true
      try {
        const response = await api.getNotes({ limit: 3 }) // 只获取最新的3条笔记
        if (response.success && response.data) {
          skincareTips.value = response.data.notes
        } else {
          // 如果API调用失败，使用默认数据
          setDefaultSkincareTipsData()
        }
      } catch (error) {
        console.error('获取护肤攻略数据失败:', error)
        // 出错时使用默认数据
        setDefaultSkincareTipsData()
      } finally {
        loadingSkincareTips.value = false
      }
    }

    // 设置默认护肤攻略数据（服务器无法访问时使用）
    const setDefaultSkincareTipsData = () => {
      skincareTips.value = [
        {
          id: 1,
          title: '秋冬季节如何正确保湿？',
          content: '秋冬季节肌肤容易干燥缺水，正确的保湿步骤和产品选择至关重要。建议使用温和的氨基酸洁面，搭配玻尿酸精华和厚重的面霜，同时注意室内加湿...',
          authorName: '肌肤专家',
          type: 'info',
          category: '护肤心得',
          createTime: '2024-03-10',
          products: ['氨基酸洁面乳', '玻尿酸精华液', '保湿面霜'],
          image: 'https://img.freepik.com/free-photo/skin-care-products-arrangement_23-2149096681.jpg'
        },
        {
          id: 2,
          title: '油皮夏季护肤攻略',
          content: '炎热夏季，油皮MM如何控油又保湿？这份清爽护肤攻略请收好。重点是选择清爽质地的产品，控制使用量，同时不要忘记补水...',
          authorName: '小雨',
          type: 'success',
          category: '护肤心得',
          createTime: '2024-02-28',
          products: ['控油洁面', '清爽水乳', '防晒霜'],
          image: 'https://img.freepik.com/free-photo/arrangement-with-natural-cosmetic-products_23-2148608356.jpg'
        },
        {
          id: 3,
          title: '敏感肌肤屏障修复指南',
          content: '敏感肌肤需要的是更温和的呵护，如何修复受损肌肤屏障？专家来支招。首先停用所有刺激性产品，使用温和的基础护肤品...',
          authorName: '敏感肌博主',
          type: 'warning',
          category: '修护记录',
          createTime: '2024-03-25',
          products: ['温和洁面乳', '舒缓修护面霜'],
          image: 'https://img.freepik.com/free-photo/arrangement-with-beauty-products-beige-background_23-2148567497.jpg'
        }
      ]
    }

    // 收藏处理函数
    const handleCollect = async (product) => {
      // 检查是否登录
      if (!isLoggedIn.value) {
        ElMessageBox.confirm(
          '收藏功能需要登录，是否前往登录?',
          '提示',
          {
            confirmButtonText: '去登录',
            cancelButtonText: '取消',
            type: 'info',
          }
        ).then(() => {
          router.push('/login?redirect=' + encodeURIComponent(router.currentRoute.value.fullPath))
        }).catch(() => {})
        return
      }

      try {
        // 先检查是否已收藏
        const checkResponse = await api.checkCollection(product.id, 'product')
        if (checkResponse.success) {
          const isCollected = checkResponse.data.isCollected
          
          // 根据当前收藏状态调用相应的API
          const response = await (isCollected ? 
            api.uncollectItem(product.id, 'product') : 
            api.collectItem(product.id, 'product'))

          if (response.success) {
            // 更新收藏数量
            if (isCollected) {
              product.collection_count--
              ElMessage.success('已取消收藏')
            } else {
              product.collection_count++
              ElMessage.success('收藏成功')
            }
          } else {
            ElMessage.error(response.message || '操作失败')
          }
        }
      } catch (error) {
        console.error('收藏操作失败:', error)
        ElMessage.error('操作失败，请稍后重试')
      } finally {
        product.collectLoading = false
      }
    }

    // 分享处理函数
    // const handleShare = (product) => {
    //   ElMessage.success(`分享：${product.name}`)
    // }
    
    // 处理个人中心点击
    const handleProfileClick = () => {
      // 检查是否登录
      if (!isLoggedIn.value) {
        ElMessageBox.confirm(
          '个人中心需要登录，是否前往登录?',
          '提示',
          {
            confirmButtonText: '去登录',
            cancelButtonText: '取消',
            type: 'info',
          }
        ).then(() => {
          router.push('/login?redirect=' + encodeURIComponent('/profile'))
        }).catch(() => {})
        return
      }
      
      router.push('/profile')
    }
    
    onMounted(() => {
      checkLoginStatus()
      fetchCarouselData()
      fetchHotProducts()
      fetchSkincareTips()
    })

    return {
      router,
      activeIndex,
      handleSelect,
      isLoggedIn,
      userInfo,
      handleLogout,
      carouselItems,
      loadingCarousel,
      handleCarouselClick,
      hotProducts,
      loadingHotProducts,
      skincareTips,
      loadingSkincareTips,
      // userShares,
      handleCollect,
      handleProfileClick,
      // handleShare
    }
  }
}
</script>

<style scoped>
.home-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f9f9f9;
}

.header-container {
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo {
  display: flex;
  flex-direction: column;
  min-width: 100px;
}

.logo h1 {
  margin: 0;
  color: #409eff;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1px;
}

.logo-subtitle {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.menu {
  flex: 1;
  justify-content: center;
  border-bottom: none;
  margin: 0 40px;
}

.el-menu-item {
  display: flex;
  align-items: center;
  font-size: 15px;
  padding: 0 16px;
}

.el-menu-item .el-icon {
  margin-right: 5px;
  font-size: 18px;
}

.user-actions {
  display: flex;
  gap: 15px;
  min-width: 180px;
  justify-content: flex-end;
}

.carousel-container {
  width: 100%;
  margin-bottom: 30px;
}

.carousel-content {
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  padding: 0 20px;
  position: relative;
}

.carousel-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.carousel-content h3, .carousel-content p {
  position: relative;
  z-index: 2;
  margin: 10px 0;
}

.carousel-content h3 {
  font-size: 36px;
  font-weight: bold;
}

.carousel-content p {
  font-size: 18px;
  max-width: 600px;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 50px;
}

.section {
  margin-bottom: 50px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.section-header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

.product-card-container, .tip-card-container, .share-card-container {
  margin-bottom: 20px;
}

.product-card {
  height: 100%;
  transition: transform 0.3s;
  overflow: hidden;
  cursor: pointer;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.product-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
}

.product-info {
  padding: 14px;
}

.product-info h3 {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: bold;
}

.product-desc {
  color: #606266;
  font-size: 14px;
  margin-bottom: 10px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.actions {
  display: flex;
  gap: 5px;
}

.tip-card {
  height: 100%;
  transition: all 0.3s;
  cursor: pointer;
}

.tip-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.tip-image {
  height: 200px;
  overflow: hidden;
  position: relative;
}

.tip-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.tip-card:hover .tip-image img {
  transform: scale(1.08);
}

.tip-content {
  padding: 20px;
}

/* 当没有图片时，调整内容区域的样式 */
.tip-card:not(:has(.tip-image)) .tip-content {
  padding-top: 30px;
}

/* 调整卡片容器的高度 */
.tip-card-container {
  margin-bottom: 20px;
  height: auto;
  display: flex;
}

.tip-card {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* 确保描述文字在没有图片时也能正常显示 */
.tip-desc {
  color: #606266;
  margin-bottom: 15px;
  min-height: 60px;
  max-height: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 1.6;
}

/* 优化标题显示 */
.tip-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 10px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.tip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.author {
  font-size: 14px;
  color: #606266;
}

.date {
  color: #909399;
  font-size: 12px;
}

.share-card {
  height: 100%;
  transition: all 0.3s;
}

.share-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

.share-info {
  padding: 15px;
}

.share-info h3 {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: bold;
}

.share-info p {
  color: #606266;
  font-size: 14px;
  margin-bottom: 15px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.share-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stats {
  display: flex;
  gap: 10px;
  color: #909399;
  font-size: 12px;
}

.stats span {
  display: flex;
  align-items: center;
  gap: 3px;
}

.welcome-user {
  display: flex;
  align-items: center;
  gap: 15px;
}

.welcome-text {
  font-size: 14px;
  color: #606266;
}

@media (max-width: 1200px) {
  .header {
    max-width: 100%;
    padding: 0 15px;
  }

  .menu {
    margin: 0 20px;
  }

  .el-menu-item {
    padding: 0 12px;
  }
}

@media (max-width: 900px) {
  .logo-subtitle {
    display: none;
  }

  .menu {
    margin: 0 10px;
  }

  .el-menu-item {
    padding: 0 8px;
    font-size: 14px;
  }

  .user-actions {
    min-width: 150px;
  }
}

@media (max-width: 768px) {
  .header {
    height: 60px;
    padding: 0 10px;
  }

  .logo h1 {
    font-size: 20px;
  }

  .menu {
    display: none;
  }

  .user-actions {
    min-width: auto;
  }
}
</style> 